const ANSWER_RESPONSE_MS = 10000;
const TEXT_SPEED = 0.04;

export { ANSWER_RESPONSE_MS, TEXT_SPEED };
